import { render, staticRenderFns } from "./SuperAdminDbBackups.vue?vue&type=template&id=06351d75&"
import script from "./SuperAdminDbBackups.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDbBackups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports